// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610211735/js/" + chunkId + "." + {"44":"92342969","225":"698a4e01","481":"77267e90","486":"c6fdead4","770":"3c2e356d"}[chunkId] + ".0.7105236682893658.chunk.js";
};